import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './facelift.css';
import './facelift-pools.css';
import './pools-redesign.css';
import './retro.css';   // the Boost Weekend look (html.retro)
import { isPoolPreview } from './supabaseClient';
import { resetDeviceSettingsForNewVersion } from './components/WhatsNew';

// major update: this device starts fresh (only the language is kept) — before anything reads it
resetDeviceSettingsForNewVersion();

// DEV-ONLY: localhost/?poolPreview shows the Pools screens with fake data
// DEV-ONLY: localhost/?feedPreview shows the Feed with fake posts
const isFeedPreview = process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('feedPreview');
// DEV-ONLY: localhost/?chatPreview shows the Chat with fake messages
const isChatPreview = process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('chatPreview');
// DEV-ONLY: localhost/?feedAlive shows a mockup of a Feed that feels alive
const isFeedAlive = process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('feedAlive');
// DEV-ONLY: localhost/?feedInsta shows a mockup of the Feed laid out like Instagram
const isFeedInsta = process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('feedInsta');
// DEV-ONLY: localhost/?feedNext shows the planned Feed (docs/feed-redesign-plan.md) with made-up activity
const isFeedNext = process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('feedNext');
// DEV-ONLY: localhost/?finalMock shows mockups of the final score card
const isFinalMock = process.env.NODE_ENV === 'development' && new URLSearchParams(window.location.search).has('finalMock');
const Root = isFinalMock ? require('./dev/FinalMock').default : isFeedNext ? require('./dev/FeedNext').default : isFeedInsta ? require('./dev/FeedInsta').default :isFeedAlive ? require('./dev/FeedAlive').default : isPoolPreview ? require('./dev/PoolsPreview').default : isFeedPreview ? require('./dev/FeedPreview').default : isChatPreview ? require('./dev/ChatPreview').default : App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
